/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { seccionMenuFiltroIdDepartament10Get } from '../fn/landing-page/seccion-menu-filtro-id-departament-10-get';
import { SeccionMenuFiltroIdDepartament10Get$Params } from '../fn/landing-page/seccion-menu-filtro-id-departament-10-get';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';

@Injectable({ providedIn: 'root' })
export class LandingPageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `seccionMenuFiltroIdDepartament10Get()` */
  static readonly SeccionMenuFiltroIdDepartament10GetPath = `/seccion-menu-filtro/{idDepartament}/${APP_CONSTANTS.TOP_JOBS_NUMBER}}`;

  /**
   * getMenuFilterSection.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `seccionMenuFiltroIdDepartament10Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  seccionMenuFiltroIdDepartament10Get$Response(params: SeccionMenuFiltroIdDepartament10Get$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return seccionMenuFiltroIdDepartament10Get(this.http, this.rootUrl, params, context);
  }

  /**
   * getMenuFilterSection.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `seccionMenuFiltroIdDepartament10Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  seccionMenuFiltroIdDepartament10Get(params: SeccionMenuFiltroIdDepartament10Get$Params, context?: HttpContext): Observable<any> {
    return this.seccionMenuFiltroIdDepartament10Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
